import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styled from 'styled-components';

const Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--medium-padding);
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--medium-padding);
  background-color: var(--beige-main);
  border-radius: var(--xsmall-border-radius);
  padding: var(--medium-big-padding);

  .quill {
    display: flex;
    flex-direction: column;
    gap: var(--medium-padding);
    background-color: transparent;
    border: none;
    min-height: auto;

    &:hover {
      border: none;
    }
  }

  .ql-toolbar.ql-snow {
    background-color: white;
    border: 1px solid var(--gray-dark);
    border-bottom: 1px solid var(--gray-dark);
    border-radius: var(--xsmall-border-radius);
    padding: var(--medium-padding) var(--semi-big-font-size);
    text-align: left;
  }

  .ql-container.ql-snow {
    background-color: transparent;
    border: none;
    padding: 0;
    font-size: var(--medium-font-size);
  }

  .ql-editor {
    padding: 0;
    min-height: 180px;
    color: var(--black-main);
  }

  .quill .ql-container .ql-blank::before {
    left: 0;
    right: 0;
    color: var(--gray-darker);
    font-size: var(--medium-font-size);
    font-style: normal;
  }
`;

const ColumnHeader = styled.div`
  font-weight: 600;
  font-size: var(--medium-font-size);
  color: var(--black-main);
`;

const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
  ],
};

export type PhishingSignCardProps = {
  enContent: string;
  daContent: string;
  onEnChange: (value: string) => void;
  onDaChange: (value: string) => void;
};

export const PhishingSignCard: React.FC<PhishingSignCardProps> = ({
  enContent,
  daContent,
  onEnChange,
  onDaChange,
}) => {
  const { t } = useTranslation();

  return (
    <Columns>
      <Column>
        <ColumnHeader>{t('common.english')}</ColumnHeader>
        <ReactQuill
          theme="snow"
          value={enContent}
          onChange={onEnChange}
          modules={quillModules}
          placeholder={t('phishingSigns.enterContent')}
        />
      </Column>
      <Column>
        <ColumnHeader>{t('common.danish')}</ColumnHeader>
        <ReactQuill
          theme="snow"
          value={daContent}
          onChange={onDaChange}
          modules={quillModules}
          placeholder={t('phishingSigns.enterContent')}
        />
      </Column>
    </Columns>
  );
};
